<template>
  <Col>
    <Col gap="xs">
      <Row
        class="cursor-pointer py-2 transition-colors hover:bg-gray-50"
        @click="expanded = !expanded"
      >
        <div class="flex-1">
          <slot name="title"></slot>
        </div>
        <Chevron :expanded :icons="[MinusIcon, PlusIcon]" />
      </Row>
      <Divider />
    </Col>

    <Col v-if="expanded">
      <slot name="items"></slot>
    </Col>
  </Col>
</template>

<script setup lang="ts">
import { MinusIcon, PlusIcon } from "@heroicons/vue/24/outline";

const expanded = defineModel<boolean>({ default: false });
</script>
